// extracted by mini-css-extract-plugin
export default {"font-renta":"DistanceModal_font-renta__NGKEw","distanceModal":"DistanceModal_distanceModal__mmihw","form":"DistanceModal_form__I5Xal","buttons":"DistanceModal_buttons__Uet5M"};